<template>
  <VContainer
    id="authentication"
    data-testid="authentication"
    class="v2-padding px-sm-6"
  >
    <SLoadingOverlay :loading="loading" />
    <VRow v-if="guestAuth" no-gutters class="mt-0">
      <VCol cols="12">
        <AuthGuest
          :btn-color="btnColor"
          @authenticated="emits('authenticated')"
          @already-exists="onAlreadyExists"
        />
      </VCol>
      <VCol>
        <VDivider />
      </VCol>
    </VRow>
    <VRow v-if="auth && !registrationOpen" class="mt-0 v2-gutters">
      <VCol
        cols="12"
        class="add-processing pb-0"
      >
        <SignIn
          v-model:already-exists="alreadyExists"
          :btn-color="btnColor"
          :open="!value"
          :guest="guest"
          :demo="demo"
          :subscription="subscription"
          @loading="onLoading"
          @authenticated="emits('authenticated')"
          @invalid-credentials="emits('invalid-credentials')"
        />
      </VCol>
      <VCol v-if="register" cols="12">
        <VDivider />
      </VCol>
    </VRow>
    <VRow v-if="registerBtn && !demo" class="mt-0 v2-gutters">
      <VCol class="text-center">
        <span v-if="!registrationOpen">
          <VDivider v-if="guestAuth" class="mb-7" />
          {{ $t('auth.p.register') }}
        </span>
        <Registration
          v-model:registration-open="registrationOpen"
          :btn-color="btnColor"
          :value="value"
          :subscription="subscription"
          class="font14"
          data-testid="registration"
          @authenticated="emits('authenticated')"
        />
      </VCol>
    </VRow>
  </VContainer>
</template>

<script lang="ts" setup>
import SignIn from '~/components/auth/SignIn.vue'
import AuthGuest from '~/components/auth/AuthGuest.vue'
import Registration from '~/components/auth/UserRegistration.vue'

interface Props {
  value?: boolean,
  demo?: boolean,
  guest?: boolean,
  auth?: boolean,
  subscription?: boolean,
  register?: boolean,
  registerBtn?: boolean,
  btnColor?: string,
  closeBtn?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  value: false,
  demo: false,
  guest: false,
  auth: false,
  subscription: false,
  register: false,
  registerBtn: false,
  btnColor: 'primary',
  closeBtn: true
})

const emits = defineEmits<{
  (e: 'authenticated' | 'invalid-credentials'): void
}>()

const registrationOpen = ref(false)
const alreadyExists = ref('')
const loading = ref(false)

const guestAuth = computed(() => !alreadyExists.value && props.guest && !registrationOpen.value)
const onAlreadyExists = (email: string) => { alreadyExists.value = email }
const onLoading = (value: boolean) => { loading.value = value }

watch(() => [props.register, props.value],
  () => {
    // reset alreadyExists on open of dialog
    alreadyExists.value = props.value ? '' : alreadyExists.value
    registrationOpen.value = props.register
  },
  { immediate: true }
)

// TODO: Rework tests so that it tests component behaviour rather than exposed values
defineExpose({
  registrationOpen,
  alreadyExists,
  onAlreadyExists
})
</script>

<style lang="scss" scoped>
@use '~/assets/scss/settings';
@use 'sass:map';

@media #{map.get(settings.$display-breakpoints, 'sm-and-down')} {
  #authentication {
    max-width: 100%;
  }
}
</style>
